import type { ThemeColor } from '@vrplatform/theme';
import { Affix, Box, type BoxProps } from '@mantine/core';
import type { ReactNode } from 'react';

export type BannerProps = {
  children?: ReactNode;
  themeColor?: ThemeColor;
} & Omit<BoxProps, 'sx'>;

export const TopAffix = ({
  children,
  themeColor = 'gray',
  ...boxProps
}: BannerProps) => {
  return (
    <Affix position={{ top: 0, left: 0, right: 0 }}>
      <Box
        sx={(theme) => ({
          boxShadow: theme.shadows.md,
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 100,
          display: 'flex',
          justifyContent: 'center',
          border: '1px solid',
          borderTop: 'none',
          borderColor: theme.colors[themeColor][5],
          backgroundColor: theme.colors[themeColor][0],
          padding: `5px ${theme.spacing.sm} `,
          borderRadius: `0  0 ${theme.radius.lg} ${theme.radius.lg}`,
        })}
        {...boxProps}
      >
        {children}
      </Box>
    </Affix>
  );
};
